import { render } from "./SelectInstructorsModal.vue?vue&type=template&id=78d8d255&scoped=true"
import script from "./SelectInstructorsModal.vue?vue&type=script&lang=js"
export * from "./SelectInstructorsModal.vue?vue&type=script&lang=js"

import "./SelectInstructorsModal.vue?vue&type=style&index=0&id=78d8d255&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d8d255"]])

export default __exports__